import * as api from '../api';
import {
    RESTAURANT_VENDOR_ORDERS_REQUEST,
    RESTAURANT_VENDOR_ORDERS_SUCCESS,
    RESTAURANT_VENDOR_ORDERS_FAIL,
} from "../constants/webOrderConstants";


// `opts.outletId`: the branch the navbar shows (undefined = every location this login may see).
export const fetchRestaurantVendorOrders = (vendorId, page = 1, limit = 10, opts = {}) => async (dispatch) => {
    try {
        dispatch({ type: RESTAURANT_VENDOR_ORDERS_REQUEST });

        const { data } = await api.fetchRestaurantVendorOrdersApi(vendorId, page, limit, opts);

        dispatch({
            type: RESTAURANT_VENDOR_ORDERS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: RESTAURANT_VENDOR_ORDERS_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        });
    }
};
